import { createFileRoute } from '@tanstack/react-router';
import { CmsPageRenderer } from '@pages/cms-page';

/**
 * Route für die Mitglied-werden-Seite (/mitglied-werden).
 * Lädt CMS-Inhalte für Slug "mitglied-werden".
 * Die CMS-Seite kann einen iFrame-Block für das EasyVerein-Formular enthalten.
 */
export const Route = createFileRoute('/mitglied-werden')({
  component: function MitgliedWerdenRoute() {
    return <CmsPageRenderer slug="mitglied-werden" />;
  },
});
